// Admin: create a new quotation request (no lead); redirects to detail after creation

import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { postWorkerApi } from '@/lib/worker-api';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

export default function AdminQuotationRequestNew() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await postWorkerApi<{ request_id: string }>('/api/quotation-request/create', {});
      if (cancelled) return;
      if (result.ok && result.data?.request_id) {
        navigate(`/store/admin/quotation-requests/${result.data.request_id}`, { replace: true });
        return;
      }
      setError(result.ok ? 'No se devolvió request_id' : (result.error ?? 'Error al crear'));
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (error) {
    return (
      <div className="space-y-6">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/store/admin/quotation-requests">← Solicitudes de cotización</Link>
        </Button>
        <p className="text-red-600">{error}</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <Button variant="ghost" size="sm" asChild>
        <Link to="/store/admin/quotation-requests">← Solicitudes de cotización</Link>
      </Button>
      <div className="flex items-center gap-2 text-zinc-600">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span>Creando solicitud...</span>
      </div>
    </div>
  );
}
